import axios from '@/axios';

export default {
  login(value) {
    return new Promise(function(resolve, reject) {
      return axios
        .post('/auth/local', value)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(function(err) {
          const error = err.response ? err.response.data : err;
          reject(error);
        });
    });
  }
};
